import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Classes from './SectionTitle.module.scss';
import { testAttributes } from '../../Constants';

export default function SectionTitle({ title, href, active })
{
    useEffect(() => 
    {}, [active]);

    return (
        <a
            href={href}
            className={`${Classes.SectionTitle} ${active ? Classes.active : ''}`}
            data-testid={testAttributes.TABLE_OF_CONTENT_LIST_ITEM_TEXT}
        >
            <p>
                {title}
                <meta content={title} itemProp="name" />
            </p>
            <meta content={href} itemProp="url" />
        </a>
    );
}
SectionTitle.propTypes = {
    active: PropTypes.bool,
    title: PropTypes.string,
    href: PropTypes.string,
};
